const CLIENT_SUBS = [
  "Where raw footage becomes magic",
  "Your editor is caffeinated and ready",
  "Let's make something your clients cry to",
  "Another beautiful love story incoming",
  "Your footage called. It's ready for its glow-up.",
  "Welcome back. Your timeline misses you.",
  "Great things are being built in here",
  "Sit back. We've got the timeline covered.",
  "Your clients are going to lose it when they see this",
  "The best part of every wedding starts right here",
];
const EDITOR_SUBS = [
  "Every frame is someone's favorite memory",
  "Behind every timeline is a real love story",
  "These aren't just clips — they're someone's best day",
  "Edit like their grandkids will watch this someday",
  "You're not just cutting video. You're preserving a moment.",
  "Someone is going to cry happy tears because of your work today",
  "Take your time. This one matters to someone.",
  "Real people. Real moments. Real trust in your hands.",
  "The couple on your timeline today chose you for a reason",
  "Make it something they'll rewatch on every anniversary",
];
const ADMIN_SUBS = [
  "Let's keep these editors fed and happy",
  "Another day, another hundred timelines",
  "The machine runs because of you",
  "Keeping the cave organized since day one",
  "You're the reason deadlines get met",
  "Behind every great edit is a great project manager",
  "Clients are happy. Editors are happy. You did that.",
  "The glue that holds the whole operation together",
  "Let's make today smoother than yesterday",
  "Every project you manage is someone's forever memory",
];

export function getCaveGreeting(role) {
  const subs = role === 'editor' ? EDITOR_SUBS : role === 'client' ? CLIENT_SUBS : ADMIN_SUBS;
  const idx = Math.floor(Math.random() * subs.length);
  return { title: "Welcome to the Editing Cave", subtitle: subs[idx] };
}
